import { Component, OnInit } from '@angular/core';
import { LicenceService } from '../licence.service';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserService } from 'src/app/shared/user/user.service';
import { AnalyticsService } from 'src/app/shared/analytics/analytics.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-licence-band',
  templateUrl: './licence-band.component.html',
  styleUrls: ['./licence-band.component.scss']
})
export class LicenceBandComponent implements OnInit {

  licenceBandData : any;
  regionCodes : string[] = [];
  graphicMode : boolean = false;

  constructor(
    private licenceService: LicenceService,
    private userService:UserService,
    private route: ActivatedRoute,
    public analyticsService: AnalyticsService,
    private router: Router,
    private location: Location
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = function() {
      return false;
    };
  }

  ngOnInit() {
    combineLatest(this.route.params, this.route.queryParams)
    .pipe(map(results => ({bandCode: results[0].bandCode, query: results[1]})))
    .subscribe(results => {
      if(results.query && results.query.regionCode){
        this.regionCodes=this.regionCodes.concat(results.query.regionCode);
      }else{
        this.regionCodes=this.regionCodes.concat(this.userService.getRegions());
      }
      this.licenceService.getLicencesByBand(this.regionCodes, results.bandCode)
      .subscribe(data => {
        this.licenceBandData=data;
      });
    });
    this.route.fragment.subscribe((fragment: string) => {
      if(fragment && fragment=='graphic'){
        this.graphicMode=true;
      }
    });
  }

  toggleActiveMode() {
    this.analyticsService.pushEvent('toggleGraphicView');
    this.graphicMode=!this.graphicMode;
    if(this.graphicMode){
      this.location.go(this.router.url.split('#')[0] +"#graphic");
    }else{
      this.location.go(this.router.url.split('#')[0]+"#table");
    }
  }

  isGraphicDataAvailable(){
    let fd= this.licenceBandData.frequencyDistributions.frequencyDistributionList;
    return fd
  }

  isGraphicMode() {
    return this.graphicMode;
  }

  isTableMode() {
    return !this.isGraphicMode();
  }

  showAsterisk(operator : any, groupedNames : any): boolean {
    return operator.value == 'Regional licences' && groupedNames;
  }
}
